import React from "react";

const SmartReaderInfo = () => {
  return (
    <>
      {/* Título principal de la sección informativa */}
      <section
        className="container dark:bg-sidom-blue"
        aria-labelledby="que-es-sr"
      >
        <h1
          id="que-es-sr"
          className="mt-[60px] text-sidom-orange dark:text-sidom-light text-3xl md:text-[40px] lg:text-[45px] leading-tight font-extrabold text-left"
        >
          ¿Qué es SIDOM Smart Reader?
        </h1>
      </section>

      {/* Descripción explicativa del producto */}
      <section
        className="w-full container mt-[30px] md:mt-[60px] leading-[1.3] flex flex-col justify-center"
        aria-label="Descripción de Smart Reader"
      >
        <div className="text-wrap text-xs sm:text-sm md:text-base lg:text-xl text-left leading-relaxed space-y-6 px-2">
          <p>
            Es la solución definitiva para la centralización, validación y
            almacenamiento de toda la documentación de comercio exterior. Es la
            única plataforma 100% Cloud/SaaS del mercado que permite optimizar
            los tiempos operativos y otorgar
            <strong> COMPLIANCE</strong> a los procesos al convertir tareas
            manuales en un proceso automático.
          </p>
        </div>
      </section>
    </>
  );
};

export default SmartReaderInfo;
